// Libs
import React, { useReducer } from "react";
import PropTypes from "prop-types";

// Context
import ToasterContext from "contexts/Toaster";

// Constants
import { TOAST_ACTIONS } from "constants/toast";

/**
 * Reduces the state of the toaster.
 * @param {*} state State to reduce
 * @param {object} action Action that was dispatched
 * @return {*} New state
 */
export function toasterReducer(state, action) {
  switch (action.type) {
    case TOAST_ACTIONS.ADD_TOAST:
      return state.concat(action.payload);
    case TOAST_ACTIONS.REMOVE_TOAST:
      return state.filter(toast => toast.id === action.id);
    default:
      throw new Error(`Unknown ${action.type} type was dispatched.`);
  }
}

export default function ToasterProvider({ children }) {
  const [state, dispatch] = useReducer(toasterReducer, []);

  return <ToasterContext.Provider value={{ state, dispatch }}>{children}</ToasterContext.Provider>;
}

ToasterProvider.propTypes = {
  children: PropTypes.node
};
